.bullet-button {
  appearance: none;
  -webkit-appearance: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  display: block;
}

.bullet-item {
  list-style: none;
  margin: 0 3px;
}

.bullets-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
}
